import React from 'react'
import _unset from 'lodash/unset'
import { getMessage } from 'lib/translator'
import { OMNI_JOURNEY_MENU } from '../utils'
import { BaseForm, Input, Select, SelectSearch } from 'components/Form'
import { StoresContext } from 'pages/omni-journey/ManageScanToWin'

const TRIGGERS = [
  { text: 'Product', value: 'product' },
  { text: 'Check-in', value: 'check-in' },
  { text: 'Campaign', value: 'campaign' },
]

class Filters extends BaseForm {
  constructor(props) {
    super(props)
  }

  handleTriggerChange = (triggerValue) => {
    const newFilterValues = { ...this.state.values }

    if (triggerValue === 'campaign') {
      _unset(newFilterValues, 'store')
      _unset(newFilterValues, 'bu')
    }

    this.setState({
      values: newFilterValues,
    })
  }

  render() {
    const isCampaignTrigger = this.state.values.trigger === 'campaign'
    const { SubmitButton, ClearButton } = this.buttons
    const { Form } = this.components
    const { type } = this.props.options

    return (
      <StoresContext.Consumer>
        {({ stores }) => (
          <Form>
            <div className="filters-section">
              <h3>Filter by</h3>
              <div className="filter-fields-section">
                {type === OMNI_JOURNEY_MENU[1] && (
                  <>
                    <Select
                      name="trigger-filter"
                      className="trigger-filter"
                      label={getMessage(`omni-journey.filter.trigger.label`)}
                      placeholder={getMessage(
                        `omni-journey.filter.trigger.placeholder`
                      )}
                      options={TRIGGERS}
                      {...this.generateStateMappers({
                        stateKeys: ['trigger'],
                        loseEmphasisOnFill: true,
                        onChange: this.handleTriggerChange,
                      })}
                    />

                    {!isCampaignTrigger && (
                      <Input
                        type="text"
                        name="Filter by BU"
                        label={getMessage('omni-journey.filter.bu.label')}
                        placeholder={getMessage(
                          'omni-journey.filter.bu.placeholder'
                        )}
                        {...this.generateStateMappers({
                          stateKeys: ['bu'],
                          loseEmphasisOnFill: true,
                        })}
                      />
                    )}

                    {!isCampaignTrigger && (
                      <SelectSearch
                        name="store-filter"
                        nameKey="name"
                        valueKey="id"
                        searchByName
                        options={stores}
                        clearSearchTextIfEmpty={true}
                        label={getMessage(`omni-journey.filter.store.label`)}
                        placeholder={getMessage(
                          `omni-journey.filter.store.placeholder`
                        )}
                        {...this.generateStateMappers({
                          stateKeys: ['store'],
                          loseEmphasisOnFill: true,
                        })}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="filter-actions-section">
              <SubmitButton testid="submit-filter">
                {getMessage('omni-journey.submit-button')}
              </SubmitButton>
              <ClearButton testid="clear-filter">
                {getMessage('omni-journey.clear-button')}
              </ClearButton>
            </div>
          </Form>
        )}
      </StoresContext.Consumer>
    )
  }
}

export default Filters
